import type { Editor } from "@tiptap/core";

export type ScratchpadSource = { fileReference: string; annotationReference?: string } & (
  | { kind: "document"; page: number; text: string }
  | {
      kind: "transcript";
      startTime: number;
      endTime: number;
      utteranceList: Array<{
        /** @deprecated */
        order?: number;
        speaker: string | number;
        dialogueText: string;
        isContext: boolean;
      }>;
    }
);

export interface ScratchpadDocument {
  version: 1;
  content: ReturnType<Editor["getJSON"]>;
  caseSummary: string;
}

export function createEmptyScratchpad(): ScratchpadDocument {
  return {
    version: 1,
    caseSummary: "",
    content: {
      type: "doc",
      attrs: undefined,
      content: [{ type: "paragraph", attrs: undefined }],
    },
  };
}

export const DATA_POINT_TINTS: Array<Record<"background" | "foreground", string>> = [
  { background: "#dbeafe", foreground: "#1e3a8a" },
  { background: "#fef08a", foreground: "#713f12" },
  { background: "#dcfce7", foreground: "#14532d" },
  { background: "#ede9fe", foreground: "#4c1d95" },
  { background: "#ffe4e6", foreground: "#881337" },
  { background: "#ccfbf1", foreground: "#134e4a" },
];

// Deterministic FNV-1a hash so every data point sharing a label shares a tint,
// including after copy, paste, undo and remount. Collisions between different
// labels are acceptable.
export function getLabelTint(label: string) {
  const normalised = label.trim().toLowerCase();
  if (normalised.length === 0) return;

  let hash = 0x811c9dc5;
  for (let index = 0; index < normalised.length; index += 1) {
    hash = Math.imul(hash ^ normalised.charCodeAt(index), 0x01000193) >>> 0;
  }

  return DATA_POINT_TINTS[hash % DATA_POINT_TINTS.length];
}
